export function getCountryForCountryCode(state, countryCode) {
    const countries = _.get(state, 'core.siteConfig.sites[0].countries', []);

    return _.find(countries, function(country) {
        return country.countryCode === countryCode;
    });
}

export function getRegionForPersonalShopperStore(personalShopperStore, country) {
    return _.find(country.regions, function(region) {
        return region.regionCode === personalShopperStore.state;
    });
}

export function isRecaptchaEnabledForSlug(store) {
    const helpSlug = _.get(store.getState(), 'help.slug');
    const recaptchaEnabledSlugs = _.get(store.getState(), 'help.recaptcha.enabledSlugs');

    return _.includes(recaptchaEnabledSlugs, helpSlug);
}
